import script from "./DomainModelReadModel.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelReadModel.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelReadModel.vue?vue&type=style&index=0&id=902e4db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-902e4db8"]])

export default __exports__